var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOurVision(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_9771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.48563 13.814C10.7402 13.814 13.3785 11.1757 13.3785 7.92118C13.3785 4.66664 10.7402 2.02832 7.48563 2.02832C4.2311 2.02832 1.59277 4.66664 1.59277 7.92118C1.59277 11.1757 4.2311 13.814 7.48563 13.814Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5569 13.814C26.8115 13.814 29.4498 11.1757 29.4498 7.92118C29.4498 4.66664 26.8115 2.02832 23.5569 2.02832C20.3024 2.02832 17.6641 4.66664 17.6641 7.92118C17.6641 11.1757 20.3024 13.814 23.5569 13.814Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48563 29.8853C10.7402 29.8853 13.3785 27.247 13.3785 23.9925C13.3785 20.7379 10.7402 18.0996 7.48563 18.0996C4.2311 18.0996 1.59277 20.7379 1.59277 23.9925C1.59277 27.247 4.2311 29.8853 7.48563 29.8853Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5569 29.8853C26.8115 29.8853 29.4498 27.247 29.4498 23.9925C29.4498 20.7379 26.8115 18.0996 23.5569 18.0996C20.3024 18.0996 17.6641 20.7379 17.6641 23.9925C17.6641 27.247 20.3024 29.8853 23.5569 29.8853Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_9771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.521484 0.957031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOurVision);
export default __webpack_public_path__ + "static/media/icon-our-vision.1a3df78cfd149f25083e2d18d47e564f.svg";
export { ForwardRef as ReactComponent };